import React, { useContext, useEffect } from 'react';
import { observer } from 'mobx-react';
import { Box } from '@wix/design-system';
import SuccessfulIllustration from '../../../../assets/images/successLarge.svg';
import { AppContextProvider } from '../../../AppLoader';

/**
 * success step of the owner-app add-auth wizard (wix-2025) — shows the success
 * illustration and auto-redirects to the post-auth URL after 1s.
 */
export const OwnerAppSuccessBody: React.FC = observer(() => {
  const {
    rootStore: { postLoginStore: store },
  } = useContext(AppContextProvider);
  useEffect(() => {
    const timer = setTimeout(() => {
      store.proceedToPostAuthUrl('2FA over OwnerApp successful');
    }, 1000);
    return () => clearTimeout(timer);
  }, [store]);
  return (
    <Box width="100%" align="center">
      <SuccessfulIllustration />
    </Box>
  );
});
